import moment from 'moment-timezone';

export const formatDateTime = (dateString) => {
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return moment.utc(dateString).tz(userTimeZone).format('DD/MM/YYYY, h:mm A');
};
